import F84Game from "../Game";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import BaseURL from "../utils/BaseURL";
import LoaderScene from "./LoaderScene";
import Fonts from "../utils/Fonts";
import InitialLoadUtils from "../utils/InitialLoadUtils";
import WebPlayerData from "../WebPlayerData";

export default class BootScene extends LoaderScene {
    loaded: boolean;

    preload(): void {
        console.log("preload");
        console.log(F84Game.Instance.locale);

        // this.load.imageLoadType = "HTMLImageElement"; // quicker load, avoids additional blob requests
        this.load.crossOrigin = 'anonymous'; // required for loading cross origin avatars

        this.load.setBaseURL(BaseURL.getBaseURL());

        const playerData = new WebPlayerData("looney-tunes-mash-up-party");
		playerData.load();

        this.loadJson("strings", "./locale/strings.json", false);
        this.loadJson("gameConfig", "./assets/json/game-config.json", false);
        this.loadImage("rotateDevice", "./assets/images/system/orientation.png");

        this.loadJson("chunks", "./assets/json/chunks.json", false);
        this.loadJson("coin-layouts", "./assets/json/coin-layouts.json", false);
        this.loadJson("tileset", "./assets/json/looney-tunes-tileset.json", false);

        const fonts = [Fonts.DefaultFont, Fonts.LuckiestGuy, Fonts.MaliBoldItalic, Fonts.MaliMediumItalic, Fonts.MaliMedium];
        for (const font of fonts) {
            // game won't progress if we try to load arial as a fallback font, so don't
            if (font != "Arial") this.load.webfont(font, font);
        }

        this.loadImages("./assets/images/temp/", {
            whiteSquare: "white-square",
            whiteCircle: "white-circle",
        });

        this.loadImages('./locale/' + F84Game.Instance.locale + '/', {
            splashLogo: "lmu-game-logo",
        });

        this.loadImages("./assets/images/splash/", {
            splashBG: "lmu-splash-bg",
            splashPlayButton: "lmu-splash-play-btn",
            splashLines1: "action-lines-1",
            splashLines2: "action-lines-2",
            splashLines3: "action-lines-3",
            loadbar: "lmu-splash-loading-bg",
            loadbarFill: "lmu-splash-loading-fill"
        });

        this.loadSpine("screen-transition", "./assets/animations/screen-transition/", "lmu-transition-screen");
        this.loadSpine("splash-characters", "./assets/animations/splash-characters/", "splash-characters", true);
        this.loadSpine("lmu-logo-stars", "./assets/animations/lmu-logo-stars/", "lmu-logo-stars", true);
        this.loadSpine("powerup-tntcrate-sky", "./assets/animations/powerup-tntcrate-sky/", "wb-powerup-tntcrate-sky", true);
        this.loadImage("whiteSquare", "./assets/images/temp/white-square.png");
    }

    create(): void {
        super.create();

        GameConfig.loadConfigFile(this.cache, "gameConfig");
        if(process.env.NODE_ENV === 'development' && GameConfig.get<boolean>('enableStats'))
        {
            F84Game.Instance.enableStats();
        }
        console.log(Strings.get("GameTitle"));
        this.next();
    }

    next(): void {
        InitialLoadUtils.hideInitialLoader();
        let startScene = GameConfig.get("startScene");
        this.game.scene.start("PreloaderScene", {
            destinationScene: startScene,
        });
        this.scene.stop(this.scene.key);
    }
}
